import { type ChangeEvent, type JSX } from "react";
import { useGetSkillDeviations } from "@/service/assessment";
import { VoiceTextArea } from "@/components";

interface FeedbackCardProps {
  assessmentId?: number;
  onChange: (e: ChangeEvent<HTMLTextAreaElement>) => void;
}

export const FeedbackCard = ({ assessmentId, onChange }: FeedbackCardProps): JSX.Element => {
  const { data: skillDeviations } = useGetSkillDeviations(assessmentId);

  return (
    <div className="flex flex-col gap-4 p-10 pt-0">
      <div className="text-eerie-black text-sm">
        <p className="mb-1">
          Before leaving your feedback, please consider the following skills.
          <br />
          We would especially value additional context and real examples from your collaboration:
        </p>
        {skillDeviations?.deviations && skillDeviations.deviations.length > 0 && (
          <ul className="mb-1 ml-5 list-disc font-bold">
            {skillDeviations.deviations.map((deviation) => (
              <li key={deviation.skill_id}>{deviation.skill_title}</li>
            ))}
          </ul>
        )}
        <p>Please share specific situations, observations, or examples. Even a few sentences are very helpful.</p>
      </div>
      <VoiceTextArea onChange={onChange} assessmentId={assessmentId} />
    </div>
  );
};
